import { Pipe, PipeTransform } from '@angular/core';
import { constants } from '@app/shared/utils/constants';

@Pipe({
  name: 'ticketLogAttendanceType',
  standalone: false,
})
export class TicketLogAttendanceTypePipe implements PipeTransform {
  transform(value?: string, args?: any): string | null {
    if (!value) {
      return null;
    }

    return constants.ticketcenter.ticketLogAttendanceTypes.find(tlat => tlat.value === value).label;
  }
}
